
// Used through the app to handle logo text component controllers

// PROPERTIES
export const ExerciserLogoTextSize = {
    XXSMALL: "xxsmall",
    XSMALL: "xsmall",
    SMALL: "small",
    MEDIUM: "medium",
    LARGE: "large"
}

// METHODS
// ---- Render logo text image size
export function renderExerciserLogoTextSize(exerciserLogoTextSize) {
    switch(exerciserLogoTextSize) {
        case ExerciserLogoTextSize.XXSMALL:
            return "h-[16px] min-h-[16px] max-h-[16px] w-[75px] min-w-[75px] max-w-[75px]"
        case ExerciserLogoTextSize.XSMALL:
            return "h-[24px] min-h-[24px] max-h-[24px] w-[112px] min-w-[112px] max-w-[112px]"
        case ExerciserLogoTextSize.SMALL:
            return "h-[32px] min-h-[32px] max-h-[32px] w-[150px] min-w-[150px] max-w-[150px]"
        case ExerciserLogoTextSize.MEDIUM:
            return "h-[40px] min-h-[40px] max-h-[40px] w-[187px] min-w-[187px] max-w-[187px]"
        case ExerciserLogoTextSize.LARGE:
            return "h-[48px] min-h-[48px] max-h-[48px] w-[224px] min-w-[224px] max-w-[224px]"
        default:
            return "h-[32px] min-h-[32px] max-h-[32px] w-[150px] min-w-[150px] max-w-[150px]"
    }
}